/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import Button from "@material-ui/core/Button";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { ReactElement } from "react";

import { useRefWithCallback } from "common/hooks/useRefWithCallback";
import { logAnalyticsEvent } from "common/analytics";
import AnalyticsEventName from "common/analytics/types/AnalyticsEventName";

export interface NotificationDialogProps extends DialogProps {
    children?: ReactElement | string;
    actions?: ReactElement;
    handleClose?: () => void;
    analyticsInfo?: any;
}
//TODO: remove
export function log(analyticsInfo: any) {
    logAnalyticsEvent({
        info: {
            sectionUrl: window.location.pathname,
            ...analyticsInfo,
        },
        name: AnalyticsEventName.ScreenDisplay,
    });
}

export default function NotificationDialog({
    children,
    actions,
    handleClose,
    analyticsInfo,
    ...dialogProps
}: NotificationDialogProps) {
    const dialogContentRef = useRefWithCallback((node) => {
        logAnalyticsEvent({
            info: {
                ...analyticsInfo,
                pageName: "error_dialog",
                displayFields: {
                    ...analyticsInfo?.displayFields,
                    errorMessage: node.textContent,
                },
            },
            name: AnalyticsEventName.ScreenDisplay,
        });
    });

    return (
        <Dialog disableBackdropClick disableEscapeKeyDown fullWidth maxWidth="xs" {...dialogProps}>
            <DialogContent>
                <div ref={dialogContentRef}>
                    <DialogContentText component="div" variant="h4" align="center" gutterBottom>
                        {children}
                    </DialogContentText>
                </div>
            </DialogContent>
            {actions ? (
                <DialogActions style={{ flexDirection: "column" }} disableSpacing>
                    {actions}
                </DialogActions>
            ) : (
                <DialogActions disableSpacing>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            )}
        </Dialog>
    );
}
